module.exports = __webpack_public_path__ + "img/jinni.daeebfa2.svg";